var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg",attrs:{"id":"main_bg"}},[_c('img',{staticClass:"login_jcd",attrs:{"src":require("../assets/jcd_logo.png"),"alt":"jcd_logo"}}),_c('activeAccount')],1)}
var staticRenderFns = []

export { render, staticRenderFns }